/* Hapsay bundle offers — size/color pickers for existing bundle products (Undies Trio, Week Pack). */
(function () {
  function money(cents, sym) {
    return sym + (cents / 100).toLocaleString('en-PH', { minimumFractionDigits: cents % 100 ? 2 : 0, maximumFractionDigits: 2 });
  }
  function init(card) {
    if (card.dataset.hpReady) return;
    card.dataset.hpReady = '1';
    var dataEl = card.querySelector('[data-hp-variants]');
    if (!dataEl) return;
    var variants = JSON.parse(dataEl.textContent);
    var sym = card.dataset.currency || '₱';
    var groups = Array.prototype.slice.call(card.querySelectorAll('[data-hp-option]'));
    var idInput = card.querySelector('input[name="id"]');
    var btn = card.querySelector('[data-hp-submit]');
    var priceEl = card.querySelector('[data-hp-price]');
    var compareEl = card.querySelector('[data-hp-compare]');
    var selected = groups.map(function (g) { return g.dataset.selected || null; });

    function match() {
      if (selected.some(function (v) { return v === null; })) return null;
      return variants.find(function (v) {
        return selected.every(function (val, i) { return v.options[i] === val; });
      }) || null;
    }
    function render() {
      groups.forEach(function (g, i) {
        var label = g.querySelector('[data-hp-selected]');
        if (label) label.textContent = selected[i] || g.dataset.placeholder;
        Array.prototype.forEach.call(g.querySelectorAll('[data-value]'), function (b) {
          b.setAttribute('aria-pressed', b.dataset.value === selected[i] ? 'true' : 'false');
        });
      });
      var v = match();
      if (!v) {
        btn.disabled = true;
        btn.textContent = card.dataset.chooseText;
        return;
      }
      idInput.value = v.id;
      if (priceEl) priceEl.textContent = money(v.price, sym);
      if (compareEl) {
        if (v.compare_at_price && v.compare_at_price > v.price) { compareEl.textContent = money(v.compare_at_price, sym); compareEl.hidden = false; }
        else if (!compareEl.dataset.fixed) { compareEl.hidden = true; }
      }
      btn.disabled = !v.available;
      btn.textContent = v.available ? card.dataset.addText.replace('[price]', money(v.price, sym)) : card.dataset.soldText;
    }
    groups.forEach(function (g, i) {
      Array.prototype.forEach.call(g.querySelectorAll('[data-value]'), function (b) {
        b.addEventListener('click', function () { selected[i] = b.dataset.value; render(); });
      });
    });
    render();
  }

  /* ---- Mode toggle (Classic / Mix your own) ---- */
  function initModes(card) {
    var modes = Array.prototype.slice.call(card.querySelectorAll('[data-hp-mode]'));
    if (!modes.length) return;
    var panels = Array.prototype.slice.call(card.querySelectorAll('[data-hp-panel]'));
    modes.forEach(function (m) {
      m.addEventListener('click', function () {
        modes.forEach(function (x) { x.setAttribute('aria-pressed', x === m ? 'true' : 'false'); });
        panels.forEach(function (p) { p.hidden = p.dataset.hpPanel !== m.dataset.hpMode; });
      });
    });
  }

  /* ---- Mix your own: pick N pairs across colors, one size for all ---- */
  function initMix(card) {
    var panel = card.querySelector('[data-hp-mix]');
    if (!panel) return;
    var sym = card.dataset.currency || '₱';
    var size = parseInt(panel.dataset.size, 10) || 3;
    var free = parseInt(panel.dataset.free, 10) || 0;
    var rows = Array.prototype.slice.call(panel.querySelectorAll('[data-hp-row]'));
    var sizeBtns = Array.prototype.slice.call(panel.querySelectorAll('[data-hp-mix-size]'));
    var sizeLabel = panel.querySelector('[data-hp-mix-size-label]');
    var step = panel.querySelector('[data-hp-mix-step]');
    var btn = panel.querySelector('[data-hp-mix-add]');
    var err = panel.querySelector('[data-hp-mix-error]');
    var counts = rows.map(function () { return 0; });
    var variants = rows.map(function (r) { return JSON.parse(r.querySelector('[data-hp-row-variants]').textContent); });
    var chosen = sizeBtns.length ? null : '';

    function variantFor(k) {
      var idx = parseInt(rows[k].dataset.sizeIndex, 10) || 0;
      if (chosen === '') return variants[k].find(function (v) { return v.available; }) || variants[k][0];
      if (chosen === null) return null;
      return variants[k].find(function (v) { return v.options[idx] === chosen; }) || null;
    }
    function total() { return counts.reduce(function (a, b) { return a + b; }, 0); }

    function render() {
      var t = total();
      var full = t >= size;
      var problem = false;
      var prices = [];
      rows.forEach(function (r, k) {
        var v = variantFor(k);
        var out = chosen !== null && (!v || !v.available);
        var note = r.querySelector('[data-hp-row-note]');
        note.textContent = out ? '— sold out in ' + chosen : '';
        r.classList.toggle('is-picked', counts[k] > 0);
        r.classList.toggle('is-out', out);
        r.querySelector('[data-hp-count]').textContent = counts[k];
        r.querySelector('[data-hp-minus]').disabled = counts[k] === 0;
        r.querySelector('[data-hp-plus]').disabled = full || out;
        if (counts[k] > 0 && out) problem = true;
        if (v) for (var i = 0; i < counts[k]; i++) prices.push(v.price);
      });
      sizeBtns.forEach(function (b) { b.setAttribute('aria-pressed', b.dataset.hpMixSize === chosen ? 'true' : 'false'); });
      if (sizeLabel) sizeLabel.textContent = chosen || 'Choose one';
      step.textContent = full
        ? panel.dataset.readyText.split('[size]').join(size)
        : panel.dataset.stepText.split('[size]').join(size).replace('[count]', t);
      var ready = full && chosen !== null && !problem;
      btn.disabled = !ready;
      if (!full) {
        btn.textContent = panel.dataset.moreText.replace('[left]', size - t);
      } else if (chosen === null) {
        btn.textContent = card.dataset.chooseText;
      } else if (problem) {
        btn.textContent = 'Swap the sold-out color';
      } else {
        prices.sort(function (a, b) { return a - b; });
        var sum = prices.reduce(function (a, b) { return a + b; }, 0);
        for (var j = 0; j < free && j < prices.length; j++) sum -= prices[j];
        btn.textContent = btn.dataset.addText.replace('[price]', money(sum, sym));
      }
      if (err) err.hidden = true;
    }

    rows.forEach(function (r, k) {
      r.querySelector('[data-hp-plus]').addEventListener('click', function () { if (total() < size) { counts[k]++; render(); } });
      r.querySelector('[data-hp-minus]').addEventListener('click', function () { if (counts[k] > 0) { counts[k]--; render(); } });
    });
    sizeBtns.forEach(function (b) { b.addEventListener('click', function () { chosen = b.dataset.hpMixSize; render(); }); });

    btn.addEventListener('click', function () {
      var items = [];
      rows.forEach(function (r, k) {
        if (counts[k] > 0) items.push({ id: variantFor(k).id, quantity: counts[k], properties: { _bundle: panel.dataset.name } });
      });
      btn.disabled = true;
      btn.setAttribute('aria-busy', 'true');
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.d.description || res.d.message || 'We couldn’t add your bundle.');
          window.location.href = root + 'cart';
        })
        .catch(function (e) {
          if (err) { err.textContent = e.message + ' Try again, or swap a color that may be sold out.'; err.hidden = false; }
          btn.disabled = false;
          btn.removeAttribute('aria-busy');
        });
    });
    render();
  }

  function initAll() {
    document.querySelectorAll('[data-hp-offer]').forEach(function (card) {
      init(card);
      if (card.dataset.hpModesReady) return;
      card.dataset.hpModesReady = '1';
      initModes(card);
      initMix(card);
    });
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', initAll); } else { initAll(); }
  document.addEventListener('shopify:section:load', initAll);
  document.addEventListener('shopify:block:select', initAll);
})();
